import { getApiBaseUrl } from "../data/authStorage";
import httpClient from "./httpClient";

const baseUrl = getApiBaseUrl();

export async function refreshAnniversaryCelebrants() {
  try {
    const response = await httpClient.post(
      `${baseUrl}/organizations/celebrants/anniversaries/refresh`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function getCurrentMonthAnniversaries(params = {}) {
  try {
    const { page = 1, limit = 10 } = params;
    const response = await httpClient.get(
      `${baseUrl}/organizations/celebrants/anniversaries/current-month?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function getAnniversariesForMonth(month, params = {}) {
  try {
    const { page = 1, limit = 20 } = params;
    const response = await httpClient.get(
      `${baseUrl}/organizations/celebrants/anniversaries?month=${month}&page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}
